import React, { useEffect } from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel'; // Import Owl Carousel JS (Important for react-owl-carousel v2.3.1 and below)
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';

import training from './images/home_training1.png';

const HomeTrainings = () => {



    useEffect(() => {
        AOS.init();
    }, []);



    const options = {
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        autoplay: true,
        smartSpeed: 1500,
        autoplayTimeout: 3500,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            800: { items: 1 },
            1150: { items: 1 },
        },
    };

    return (
        <div>
            <div className='home_training_section' data-aos="fade-up" data-aos-duration="2000">
                <div className="container-fluid">
                    <div >





                        <div className='row'>
                            <div className='col-lg-6 home_training_section_img'>
                                <img src={training} className='img-fluid' />
                            </div>
                            <div className='col-lg-6  m-auto'>
                                <OwlCarousel className="owl-theme mt-5" {...options}> {/* Use the OwlCarousel Component */}


                                    <div className='home_training_section_content'>
                                        <h2>Full Stack Development</h2>
                                        <h6>FEATURED COURSES</h6>
                                        <p className='text-justify'> Develop dynamic, end-to-end web solutions with Hamo Tech's Full Stack Development course, blending front-end and back-end skills seamlessly.</p>

                                        <h3>Learning outcomes</h3>
                                        <ul>
                                            <li><i class="ri-check-double-line"></i><span>
                                                Expertise in React, Node.js, Express, and MongoDB.</span></li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Build, deploy, and maintain scalable applications.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Develop RESTful APIs and integrate them with front-end designs.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>
                                                    Real-time project development experience.
                                                </span>
                                            </li>
                                        </ul>

                                        <Link to="/contact-us">
                                        <button>
                                            Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                        </button>
                                        </Link>
                                    </div>



                                    <div className='home_training_section_content'>
                                        <h2>Java And AWS Course</h2>
                                        <h6>FEATURED COURSES</h6>
                                        <p className='text-justify'> Master Java programming and cloud technologies with Hamo Tech's comprehensive
                                            course. This training is designed for both beginners and experienced developers,
                                            focusing on the latest industry trends in Java and AWS.</p>

                                        <h3>Learning outcomes</h3>
                                        <ul>
                                            <li><i class="ri-check-double-line"></i><span>
                                                Comprehensive coverage of Java and AWS
                                                services.</span></li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Hands-on labs and real-world
                                                    projects.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Training in cloud deployment and
                                                    management.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>
                                                    Preparation for industry-recognized
                                                    certifications.
                                                </span>
                                            </li>
                                        </ul>

                                        <Link to="/contact-us">
                                        <button>
                                            Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                        </button>
                                        </Link>
                                    </div>

                                    <div className='home_training_section_content'>
                                        <h2>Data Science and Machine Learning</h2>
                                        <h6>FEATURED COURSES</h6>
                                        <p className='text-justify'> Dive into the world of data analytics and AI with Hamo Tech's Data Science program. Learn to harness the power of machine learning algorithms and data visualization tools.</p>

                                        <h3>Learning outcomes</h3>
                                        <ul>
                                            <li><i class="ri-check-double-line"></i><span>
                                                Grasp core concepts of Python and R programming.</span></li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Understand data preprocessing and analysis.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Work on machine learning algorithms and AI models.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>
                                                    Build projects using real-world datasets.
                                                </span>
                                            </li>
                                        </ul>

                                        <Link to="/contact-us">
                                        <button>
                                            Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                        </button>
                                        </Link>
                                    </div>


                                    <div className='home_training_section_content'>
                                        <h2>Web Development Bootcamp</h2>
                                        <h6>FEATURED COURSES</h6>
                                        <p className='text-justify'> Master the art of creating stunning websites with Hamo Tech's hands-on Web Development Bootcamp. This course covers everything from front-end frameworks to back-end logic.</p>

                                        <h3>Learning outcomes</h3>
                                        <ul>
                                            <li><i class="ri-check-double-line"></i><span>
                                                Mastery of HTML, CSS, and JavaScript.</span></li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Proficiency in popular frameworks like React and Angular.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Building responsive and interactive web applications.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>
                                                    Understanding web hosting and deployment techniques.
                                                </span>
                                            </li>
                                        </ul>

                                        <Link to="/contact-us">
                                        <button>
                                            Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                        </button>
                                        </Link>
                                    </div>


                                    <div className='home_training_section_content'>
                                        <h2>Cloud Computing with Azure</h2>
                                        <h6>FEATURED COURSES</h6>
                                        <p className='text-justify'>Elevate your cloud computing expertise with Hamo Tech's Azure training. Learn to design and manage scalable cloud solutions efficiently.</p>

                                        <h3>Learning outcomes</h3>
                                        <ul>
                                            <li><i class="ri-check-double-line"></i><span>
                                                In-depth knowledge of Microsoft Azure services and architecture.</span></li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Build and deploy cloud-based applications.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>Real-world labs for managing cloud resources.</span>
                                            </li>
                                            <li> <i class="ri-check-double-line"></i>
                                                <span>
                                                    Preparation for Azure certifications.
                                                </span>
                                            </li>
                                        </ul>

                                        <Link to="/contact-us">
                                        <button>
                                            Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                        </button>
                                        </Link>
                                    </div>


                                </OwlCarousel>


                            </div>
                        </div>



                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeTrainings
